import { render, staticRenderFns } from "./ModalDireccion.vue?vue&type=template&id=5c7c3c72&scoped=true&"
import script from "./ModalDireccion.vue?vue&type=script&lang=js&"
export * from "./ModalDireccion.vue?vue&type=script&lang=js&"
import style0 from "./ModalDireccion.vue?vue&type=style&index=0&id=5c7c3c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c3c72",
  null
  
)

export default component.exports